module.exports = __webpack_public_path__ + "static/img/photo_rule.b4f1531.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_rule.png
// module id = ny1M
// module chunks = 12